/* eslint-disable better-mutation/no-mutation */

import { createReducer } from '@reduxjs/toolkit';

const initialState = {
    ignoreProperties: []
};

export default createReducer(initialState, {
    RESET_IGNORE_PROPERTIES: (state) => {
        state.ignoreProperties = [];
    },
    ADD_IGNORE_PROPERTIES: (state, action) => {
        state.ignoreProperties = [
            ...new Set([...state.ignoreProperties, ...action.payload])
        ];
    },
    REMOVE_IGNORE_PROPERTIES: (state, action) => {
        state.ignoreProperties = state.ignoreProperties.filter(
            (prop) => !action.payload.includes(prop)
        );
    }
});
